import { trackManagementTabsClick } from '@src/sensor';
import { Tabs } from 'antd';
import React, { useState } from 'react';
import InsensitiveCCSConfiguration from './InsensitiveCCSConfiguration/InsensitiveCCSConfiguration';
import SensitiveCCSConfiguration from './SensitiveCCSConfiguration/SensitiveCCSConfiguration';

const SENSITIVE_CCS_CONFIGURATION = 'sensitive_css-configuration';
const INSENSITIVE_CCS_CONFIGURATION = 'insensitive_css-configuration';

const CCSConfiguration = () => {
  const [activeKey, setActiveKey] = useState<string>(SENSITIVE_CCS_CONFIGURATION);
  const items: any[] = [
    {
      key: SENSITIVE_CCS_CONFIGURATION,
      label: `Sensitive CCS Configuration`,
      children: <SensitiveCCSConfiguration />,
    },
    {
      key: INSENSITIVE_CCS_CONFIGURATION,
      label: `Insensitive CCS Configuration`,
      children: <InsensitiveCCSConfiguration />,
    },
  ];

  return (
    <div>
      <Tabs
        activeKey={activeKey}
        items={items}
        onChange={(activeKey) => {
          trackManagementTabsClick({ activeKey });
          setActiveKey(activeKey);
        }}
      />
    </div>
  );
};

export default CCSConfiguration;
